import { Grid, Tab, Tabs } from '@mui/material';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { MDTypography } from '../../../../../Component/Common/Components/MDTypography';
import { useRouteMatch } from '../../../../../Helpers/RouteMatcher';
import { OrganisationAtom } from '../../../../../State/Organisation.Atom';
import { MerSetaSdeDetails } from './MerSetaSdeDetails';
import { MersetaExternalAttendees } from '../../../Attendees/MersetaExternalAttendees';
import { InterventionAtom } from '../Intervention.Atom';
import { AncillaryCostsPage } from '../AncillaryCosts/AncillaryCostsPage';
import { TrainingTypes } from '../../../../../Component/Model/Enum/BEE123Enums';
import { BreadCrumb } from '../../../../../Component/Common/Components/BreadCrumb/BreadCrumb';

export const ExternalTrainingBaseForm = () => {
    const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);
    const routes = [
        `/organisation/training/External/form/Details`,
        `/organisation/training/External/form/Attendees`,
        `/organisation/training/External/form/AncillaryCosts`
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    const selectedSDE = useRecoilValue(InterventionAtom);
    const SDEExists = selectedSDE.id > 0;

    return (
        <>
            <BreadCrumb
                titles={['Manage Training', 'External', 'Intervention']}
                hrefs={['/organisation/training/External', '/organisation/training/External' , '']}
                currentLinkIndex={2}
            />

            <MDTypography variant="h4" style={{ paddingBottom: "20px" }}>
                {!SDEExists? "Capture" : "Edit"} External Training
            </MDTypography>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Intervention Details" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Attendees" value={routes[1]} to={routes[1]} component={Link} disabled={!SDEExists} />
                        <Tab label="Ancillary Costs" value={routes[2]} to={routes[2]} component={Link} disabled={!SDEExists} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <MerSetaSdeDetails/>
                        </Route>
                        <Route path={routes[1]}>
                            <MersetaExternalAttendees organisationId={+peopleAndTrainingOrganisation.OrganisationId} organisationName={peopleAndTrainingOrganisation.OrganisationName}/>
                        </Route>
                        <Route path={routes[2]}>
                            <AncillaryCostsPage interventionType={TrainingTypes.External}/>
                        </Route>
                    </Switch>
                </Grid>
            </Grid>

        </>

    )
}

